import styles from "./styles.module.scss";
import Widget from "./widget";

export { styles};
export default Widget;